



































import { Component, Vue } from "vue-property-decorator";
import { i18n } from "../plugins/i18n";
import { subDays, format } from "date-fns";

@Component({
  metaInfo: {
    meta: [
      {
        name: "og:url",
        property: "og:url",
        content: process.env.VUE_APP_FRONT_END_APP_URL,
      },
      {
        name: "twitter:card",
        content: "summary_large_image",
      },
    ],
    link: [
      {
        rel: "canonical",
        href: window.location.href,
      },
      {
        rel: "image_src",
        href: "https://www.merezha.com.ua/img/merezha-share-image.jpg",
      },
    ],
  },
})
export default class BiModule extends Vue {
  lastDayOfPreviousMonth: any = 30;
  previousMonth: any = new Date();
  previousYear: any = new Date();
  currentYear: any = new Date().getFullYear();

  get date() {
    return format(subDays(new Date(), 1), "dd.MM.yyyy");
  }

  previousMonthDate() {
    this.previousMonth.setDate(1);
    this.previousMonth.setHours(-1);
    this.lastDayOfPreviousMonth = this.previousMonth.getDate();
    this.previousYear = this.previousMonth.getFullYear();
    this.previousMonth = `${1 + this.previousMonth.getMonth()}`.padStart(
      2,
      "0"
    );
  }

  mounted() {
    this.previousMonthDate();
  }
}
